export const decodeHtmlEntities = (html) => {
  if (!html || typeof html !== "string") return html || "";
  const textarea = document.createElement("textarea");
  textarea.innerHTML = html;
  return textarea.value;
};

export const hasRichTextContent = (value) => {
  const text = String(value || "")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&#160;/gi, " ")
    .replace(/\u00a0/g, " ")
    .trim();

  return text.length > 0;
};

export const getRichTextLength = (value) => String(value || "").length;
